import React from "react";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import Tooltip from "@mui/material/Tooltip";

export default function CustomAddButton({ title, href, onClick }) {
    return (
        <>
            {href && (
                <Tooltip title={title ? title : ""} arrow>
                    <Fab color="primary" aria-label="add" sx={{ position: "fixed", right: "20px", bottom: "20px", left: "auto", top: "auto" }} href={href}>
                        <AddIcon />
                    </Fab>
                </Tooltip>
            )}
            {!href && (
                <Tooltip title={title ? title : ""} arrow>
                    <Fab
                        color="primary"
                        aria-label="add"
                        sx={{ position: "fixed", right: "20px", bottom: "20px", left: "auto", top: "auto" }}
                        onClick={onClick}
                    >
                        <AddIcon />
                    </Fab>
                </Tooltip>
            )}
        </>
    );
}
